<template>
  <div>
    <el-dialog v-el-drag-dialog custom-class="" :close-on-click-modal="false" :visible.sync="innerVisible" :title="$t('CargoMsg.Cargo_ExpenseSelection')" :show-close="false" @close="cancel">

      <cargo-ag-grid
        :show-side-bar="false"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
        :style="{width:'100%',height:'300px'}"
      />
      <div slot="footer">
        <el-button type="primary" no="1" size="mini" @click="enterEvent">{{ $t('Billing.billingView_Determine') }}</el-button>
        <el-button no="2" size="mini" @click="cancel">{{ $t('Billing.billingView_Close') }}</el-button>
      </div>
    </el-dialog>
    <!--费用调整弹窗-->
    <charge-adjustment-dialog
      v-if="showChargeAdjustmentDialog"
      :visible.sync="showChargeAdjustmentDialog"
      :default-properties="chargeDefaultProperties"
      @chargeAdjustmentCallBackEvent="chargeJustCallBackEvent"
    />
  </div>
</template>

<script>

import chargeAdjustmentDialog from '@/components/Cargo/Act/chargeAdjustmentDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { getGridSelected } from '@/utils/agGrid'
import lodash from 'lodash'
import * as BillingNativeUtils from '@/class/cargo/model/utils/BillingNativeUtils'

export default {
  name: 'JobChargeAdjustmentDialog',
  components: { chargeAdjustmentDialog },
  props: {
    visible: { type: Boolean, required: true }, // 是否隐藏
    defaultProperties: { type: Object, required: true } // 弹框打开时默认传递条件
  },
  data() {
    return {
      showChargeAdjustmentDialog: false,
      chargeAdjustmentConditions: [],
      innerVisible: this.visible,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: this.defaultProperties ? this.defaultProperties.charges : [],
      chargeDefaultProperties: this.defaultProperties
    }
  },
  computed: {},
  created() {
    this.columnDefs = [
      {
        headerName: '', width: 60, checkboxSelection: true,
        sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
        headerCheckboxSelection: true
      },
      { headerName: this.$t('Billing.billingCharge_chargeItem'), field: 'chargeChargeItemId', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
        } },
      { headerName: this.$t('Billing.billingCharge_paymentType'), field: 'chargeReceivable', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.chargeReceivableLabelFun(params.value)
        } },
      { headerName: this.$t('Billing.billingCharge_currency'), field: 'chargeCurrency', width: 110 },
      { headerName: this.$t('Billing.billingForm_unit'), field: 'chargeMeasure', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
        } },
      { headerName: this.$t('Billing.billingCharge_amount'), field: 'chargeQuantity', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        } },
      { headerName: this.$t('Billing.billingJob_unitPrice'), field: 'chargeUnitRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 3)
        } },
      { headerName: this.$t('Billing.billingJob_taxIncludedPrice'), field: 'chargeAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingJob_taxExcludedPrice'), field: 'chargeExcludingTaxAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingJob_taxRate'), field: 'chargeTaxRate', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_taxAmount'), field: 'chargeTaxAmount', width: 110,
        cellRenderer: (params) => {
          return ColumnUtils.numberColumnLabelFunc(params.value, 2)
        } },
      { headerName: this.$t('Billing.billingCharge_remarks'), field: 'chargeRemarks', width: 110 }
    ]
  },
  beforeMount() {
  },
  methods: {
    cancel() {
      this.$emit('update:visible', false)
    },
    enterEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (chooseRows.length !== 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (!BillingNativeUtils.checkJustCharge(chooseRows[0])) {
        return
      }
      const chargeDefaultProperties = this.chargeDefaultProperties
      chargeDefaultProperties['modifyCharge'] = lodash.cloneDeep(chooseRows[0])
      this.showChargeAdjustmentDialog = true
    },
    chargeJustCallBackEvent(justCharges) {
      this.$emit('jobChargeAdjustmentCallBackEvent', justCharges)
    }
  }
}
</script>
